import React, { useEffect, useRef, memo } from "react";
import { ChartStyle } from "./ChartFilterBar";

interface TradingViewAdvancedChartProps {
  symbol?: string;
  theme?: "light" | "dark";
  interval?: string;
  backgroundColor?: string;
  gridColor?: string;
  allowSymbolChange?: boolean;
  hideSideToolbar?: boolean;
  hideTopToolbar?: boolean;
  hideLegend?: boolean;
  hideVolume?: boolean;
  withdateranges?: boolean;
  studies?: string[];
  compareSymbols?: string[];
  watchlist?: string[];
  chartStyle?: ChartStyle;
}

function TradingViewAdvancedChart({
  symbol = "CSELK:JKH.N0000",
  theme = "dark",
  interval = "D",
  backgroundColor = "#0F0F0F",
  gridColor = "rgba(242, 242, 242, 0.06)",
  allowSymbolChange = true,
  hideSideToolbar = false,
  hideTopToolbar = false,
  hideLegend = false,
  hideVolume = false,
  withdateranges = true,
  studies = [],
  compareSymbols = [],
  watchlist = [],
  chartStyle = "1",
}: TradingViewAdvancedChartProps) {
  const container = useRef<HTMLDivElement>(null);
  const scriptInjected = useRef(false);

  useEffect(() => {
    if (!container.current || scriptInjected.current) return;
    scriptInjected.current = true;

    const script = document.createElement("script");
    script.src =
      "https://s3.tradingview.com/external-embedding/embed-widget-advanced-chart.js";
    script.type = "text/javascript";
    script.async = true;
    script.innerHTML = JSON.stringify({
      allow_symbol_change: allowSymbolChange,
      calendar: false,
      details: false,
      hide_side_toolbar: hideSideToolbar,
      hide_top_toolbar: hideTopToolbar,
      hide_legend: hideLegend,
      hide_volume: hideVolume,
      hotlist: false,
      interval,
      locale: "en",
      save_image: true,
      style: chartStyle,
      symbol,
      theme,
      timezone: "Asia/Colombo",
      backgroundColor,
      gridColor,
      watchlist,
      withdateranges,
      compareSymbols: compareSymbols.map((symbol) => ({
        symbol,
        position: "SameScale",
      })),
      studies,
      autosize: true,
      hide_compare: true,
    });

    container.current.appendChild(script);
  }, []);

  return (
    <div
      className="tradingview-widget-container"
      ref={container}
      style={{ height: "100%", width: "100%" }}
    >
      <div
        className="tradingview-widget-container__widget"
        style={{ height: "calc(100% - 32px)", width: "100%" }}
      />
    </div>
  );
}

export default memo(TradingViewAdvancedChart);
